import React, { Component, PropTypes } from 'react';
import introActivate from './introActivate';


export default class TimelineIntroElement extends Component {
	static propTypes = {

	};
	static defaultProps = {

	};

	constructor(props) {
		super(props);


	}

	componentDidMount() {
		this.introActivate = introActivate(
			this.getElement.bind(this),
			this.props.browser,
			this.getIntroElement.bind(this),
			this.getIntroElementFade.bind(this),
			this.getIntroElementStopper.bind(this)
		);
		this.props.browser.scroll.register(this.introActivate);
	}

	componentWillUnmount() {
		this.props.browser.scroll.deregister(this.introActivate);
	}

	shouldComponentUpdate(nProps, nState) {
		return (
			nState !== this.state ||
			nProps !== this.props
		);
	}

	componentDidUpdate() {}

	render() {
		if (this.props.year) {
			return (
				<div className={'timeline-hero-year__intro ' + this.props.before} ref='introWrap'>
					<div className='timeline-hero-year__intro__element' ref='introElement'>
						<p className='timeline-hero-year__intro__content'>
							<span ref='introElementStopper'>{this.props.awardTitle + ' — ' + this.props.year + ':'}</span>
							<strong className='timeline-hero-year__intro__content--fade' ref='introElementFade'>
								<span className='timeline-hero-year__intro__content--name'>{this.props.title}</span>
							</strong>
						</p>
					</div>
				</div>
			);
		} else {
			return (
				<div className={'timeline-hero__intro ' + this.props.before} ref='introWrap'>
					<div className='timeline-hero__intro__element' ref='introElement'>
						<p className='timeline-hero__intro__content'>
							<span ref='introElementStopper'>{this.props.winDate.month + ' — ' + this.props.winDate.year}</span>
							<strong className='timeline-hero__intro__content--fade' ref='introElementFade'>
								<span>{this.props.awardTitle}</span>
								<span className='timeline-hero__intro__content--name'>{this.props.title}</span>
							</strong>
						</p>
					</div>
				</div>
			);
		}
	}

	getElement() {
		return this.refs.introWrap;
	}

	getIntroElement() {
		return this.refs.introElement;
	}

	getIntroElementFade() {
		return this.refs.introElementFade;
	}

	getIntroElementStopper() {
		return this.refs.introElementStopper;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/timeline/timelineIntroElement.js
 **/